// extracted by mini-css-extract-plugin
export default {"productDescription":"j_-z","featuredDescription":"k_-z","description":"l_-z","more":"m_-z","descriptionSku":"n_-z"};